module.exports = __webpack_public_path__ + "img/trends.afa22b2a.png";